import { FormType } from '@/store/types';

export default {
  title: 'Pro rychlý výpočet žádosti o úvěr zvolte jednu z možností:',
  variants: {
    [FormType.InvestmentLoan]: {
      title: 'Podnikám',
      description: 'Beru si úvěr jako živnostník nebo podnikatel a mám IČO.',
      action: 'Podnikatelský úvěr',
    },
    [FormType.ConsumerLoan]: {
      title: 'Nepodnikám',
      description: 'Půjčuji si jako fyzická osoba.',
      action: 'Spotřebitelská půjčka',
    },
  },
  checkmarks: [
    'Připravíme vám férovou nabídku na míru.',
    'Bez skrytých poplatků.',
    'Zakládáme si na osobním přístupu.',
    'Žádost vyřešíte online z pohodlí domova.',
  ],
  chooseTitle: ' Pro rychlé vyřízení žádosti o úvěr zvolte jednu z možností:',
};
